import { z } from "zod";
export const PULSE_BEHAVIOURS = ["food", "movement", "sleep", "stress", "connection"];
export const pulseBehaviourSchema = z.enum(PULSE_BEHAVIOURS);
export const PULSE_AGREEMENT_LABELS = [
    "Strongly disagree",
    "Disagree",
    "Neutral",
    "Agree",
    "Strongly agree",
];
export const PULSE_MIN = 1;
export const PULSE_MAX = 5;
export const PULSE_ITEMS = [
    {
        id: "food",
        category: "Food",
        q: "I eat a serving of vegetables at both lunch and dinner.",
    },
    { id: "movement", category: "Movement", q: "I feel physically fit." },
    { id: "sleep", category: "Sleep", q: "I feel my sleep quality is good." },
    {
        id: "stress",
        category: "Stress",
        q: "I make time to recharge outside of work.",
    },
    {
        id: "connection",
        category: "Connection",
        q: "I can rely on my friends or family when I need help.",
    },
];
// Partial: a member can be mid-way through the five, and an onboarding
// baseline may be missing behaviours they skipped. Completeness is enforced at
// submit, not here.
export const pulseAnswersSchema = z.partialRecord(pulseBehaviourSchema, z.number().int().min(PULSE_MIN).max(PULSE_MAX));
export function pulseMean(answers) {
    const values = PULSE_BEHAVIOURS.map((id) => answers[id]).filter((v) => v != null);
    if (values.length === 0)
        return null;
    return values.reduce((sum, v) => sum + v, 0) / values.length;
}
/**
 * Movement since the onboarding baseline, per behaviour. Only behaviours
 * present in both reads can move, so a baseline the member never answered is
 * absent rather than counted as zero change.
 */
export function pulseShifts(baseline, current) {
    const shifts = [];
    for (const id of PULSE_BEHAVIOURS) {
        const before = baseline[id];
        const after = current[id];
        if (before == null || after == null)
            continue;
        shifts.push({ id, baseline: before, current: after, delta: after - before });
    }
    return shifts;
}
//# sourceMappingURL=pulse.js.map